// Menu photos are shrunk in the browser before upload: phone photos are often
// several megabytes, but a menu thumbnail never needs more than ~1200px.

export const fitWithin = (width, height, maxDimension) => {
  const scale = Math.min(1, maxDimension / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
};

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("خواندن تصویر ناموفق بود."));
    };
    image.src = url;
  });

// Returns a JPEG Blob at most `maxDimension` px on its longest side. If the
// result would not be smaller than the original, the original file is kept.
export const compressImage = async (file, { maxDimension = 1200, quality = 0.82 } = {}) => {
  const image = await loadImage(file);
  const { width, height } = fitWithin(image.naturalWidth, image.naturalHeight, maxDimension);

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  // JPEG has no transparency: paint transparent PNG/WebP areas white.
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
  return blob && blob.size < file.size ? blob : file;
};
